import { useDeleteActionPlan } from '@/hooks/v2/useDeleteActionPlan';
import { useApplicationContext } from '@/context/v1/Application/context';

export function useActionPlanActions() {
	const { company, organization } = useApplicationContext();
	const { mutateAsync: deleteActionPlan } = useDeleteActionPlan();

	async function handleDelete(id: string) {
		await deleteActionPlan({
			ids: [id],
			company_id: company.id,
			organization_id: organization.id
		});
	}

	return { handleDelete };
}
